import React from 'react';
import Icon from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Heading4, Body } from '~/components/atom/Typography';
import Input from '~/components/molecule/Input';
import { TEXT } from '../../constants';
import SectionContainer from '../SectionContainer';
import type {
  UpdateSettingsAction,
  UpdateSettingsState,
} from '../../reducers/settingsReducer';
import type { TouchedFields } from '../../hooks/useSettingsValidation';

type Props = {
  updateSettings: UpdateSettingsState;
  dispatch: React.Dispatch<UpdateSettingsAction>;
  flynckErrors: Array<string>;
  setFieldTouched: (field: keyof TouchedFields) => void;
};

const FlynkSettingsSection: React.FCC<Props> = ({
  updateSettings,
  dispatch,
  flynckErrors,
  setFieldTouched,
}) => (
  <SectionContainer
    gap="base"
    backgroundColor={{ group: 'primary', variant: 'translucent' }}
    padding={['s']}
    border={{ radius: 'base' }}
  >
    <Heading4 size="m" margin={[null]}>
      {TEXT.flynckHeader}
    </Heading4>
    <JustificationContainer direction="column" gap="base" width="100%">
      <JustificationContainer gap="xs" align="center">
        <Icon
          name="exclamation"
          color={{ group: 'warning', variant: 'dark' }}
        />
        <Body
          size="s"
          margin={['xxxs', null, null, null]}
          color={{ group: 'warning', variant: 'dark' }}
        >
          {TEXT.flynckSettingsWarning}
        </Body>
      </JustificationContainer>
      {flynckErrors.length > 0 && (
        <Body color={{ group: 'danger', variant: 'dark' }} margin={[null]}>
          {flynckErrors[0]}
        </Body>
      )}
      <Input
        type="text"
        value={updateSettings?.flynck?.importSetupID}
        onChange={e => {
          setFieldTouched('flynck');
          dispatch({
            type: 'SET_FLYNCK_IMPORT_SETUP_ID',
            payload: e.target.value,
          });
        }}
        label={{ text: TEXT.importSetupIDLabel }}
        width="100%"
      />
      <Input
        type="text"
        value={updateSettings?.flynck?.contextID}
        onChange={e => {
          setFieldTouched('flynck');
          dispatch({
            type: 'SET_FLYNCK_CONTEXT_ID',
            payload: e.target.value,
          });
        }}
        width="100%"
        label={{ text: TEXT.contextIDLabel }}
      />
    </JustificationContainer>
  </SectionContainer>
);

export default FlynkSettingsSection;
